module.exports = __webpack_public_path__ + "vc.2f8354cf0fb65fad79f3.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/flag-icon-css/flags/vc.svg
// module id = ../../../../../theme/scss/icons/flag-icon-css/flags/vc.svg
// module chunks = styles